module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av42-774643b137a993aff1e6d1ec741c8ceb.jpg";